import { Modal } from "@/components/modal/Modal";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useState } from "react";
import QuestionForm from "../QuestionForm";
import IconButton from "@/components/buttons/IconButton";
import type { IQuestion } from "@/types/types";
import Title from "@/components/modal/Title";

const ModalEditQuestion = ({ question }: { question: IQuestion }) => {
  const translate = useTranslate();
  const [isAdding, setIsAdding] = useState(false);

  const handleOnSave = () => {
    setIsAdding(true);
  };

  const handleOnClose = () => {
    setIsAdding(false);
  };

  return (
    <>
      <IconButton icon="pencil" onClick={handleOnSave} />
      {isAdding && (
        <Modal>
          <Modal.Header>
            <Title title={translate("editQuestion")} />
          </Modal.Header>
          <Modal.Content>
            <QuestionForm item={question} onClose={handleOnClose} />
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

export default ModalEditQuestion;
